// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-checkout__thankyou',
    // #endregion
    // #region Events
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        cart: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        status: {
            type: Object,
            required: true,
            default: {}
        }
    },
    // #endregion
});
// #endregion
